import { Button, Icon, Text } from "@ttc3k/trekker";
import { Megaphone, Xmark } from "iconoir-react";
import { Collapsible } from "shared/components/molecules";
import { Flex } from "styled-system/jsx";
import { getMultilingualString } from "shared/utils";
import { Multilingual } from "gql/generated.ts";

type MaintenanceNoticeBannerProps = {
  message: Multilingual;
  hashMessage: string;
  open: boolean;
  onClose: () => void;
};

export const CLOSE_MAINTENANCE_BANNER_KEY = "CLOSE_MAINTENANCE_BANNER";

export const MaintenanceNoticeBanner = ({
  message,
  hashMessage,
  open,
  onClose,
}: MaintenanceNoticeBannerProps) => {
  const handleClose = () => {
    // Save the closure of this maintenance notice banner to local storage so
    // the user doesn't see the same notice again once they close it.
    localStorage.setItem(CLOSE_MAINTENANCE_BANNER_KEY, hashMessage);
    onClose();
  };
  return (
    <Collapsible open={open}>
      <Flex
        w={"full"}
        h={"64px"}
        bg={"linear-gradient(90deg, #05C 0%, #1D7AFC 100%)"}
        gap={"600"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={"300"}
      >
        <Flex gap={"150"} color={"white"}>
          <Icon Element={Megaphone} opacity={0.75} />
          <Text visual={"bodyMedium"}>{getMultilingualString(message)}</Text>
        </Flex>

        <Button
          visual={"unstyled"}
          Icon={Xmark}
          color={"white"}
          css={{ "& > svg": { width: "icons.lg", height: "icons.lg" } }}
          _hover={{ color: "white/75" }}
          onClick={handleClose}
        />
      </Flex>
    </Collapsible>
  );
};
